<template>
  <div class="BookingInstructions" v-if="!loading">
    <div class="BookingInstructions-div" style="padding-bottom: 10px">
    
       <p class="Quick-reply">预定说明</p>
        <div
          v-for="(item, index) in book_notice"
          :key="index"
          :class="item.key != '出票速度' ? 'BookingInstructions-padd' : ''"
        >
          <div v-if="item.key != '出票速度'">
            <p class="BookingDetails-title">
           
              <span class="BookingDetails-title-key">
                {{ item.key }}
              </span>
              
             <span v-html="item.value" class="BookingDetails-content-text">
              </span>
            </p>
            <div style="clear: both"></div>
          </div>
        </div>
        <p
          v-if="book_notice == '' || book_notice == null || book_notice == []"
          class="BookingDetails-information"
        >
          暂无信息
        </p>
     
    </div>

    <div class="BookingInstructions-div">
     
        <p class="Quick-reply">费用说明</p>
        <div
          v-for="(item, index) in cost_description"
          :key="'info' + index"
          class="BookingInstructions-padd"
        >
          <p class="BookingDetails-title">
            {{ item.key }}
          </p>
          <p v-html="item.value" class="BookingDetails-content"></p>
        </div>
        <p
          v-if="
            cost_description == '' ||
            cost_description == null ||
            cost_description == []
          "
          class="BookingDetails-information"
        >
          暂无信息
        </p>
    </div>

    <div class="BookingInstructions-div">
     
        <p class="Quick-reply">其他说明</p>
        <div
          v-for="(item, index) in other_description"
          :key="'info1' + index"
          class="BookingInstructions-padd"
        >
          <p class="BookingDetails-title">
            {{ item.key }}
          </p>
          <p v-html="item.value" class="BookingDetails-content"></p>
        </div>

        <p
          v-if="
            other_description == '' ||
            other_description == null ||
            other_description == []
          "
          class="BookingDetails-information"
        >
          暂无信息
        </p>
     
    </div>

    <div class="BookingInstructions-div">
     
        <p class="Quick-reply">使用说明</p>
        <div
          v-for="(item, index) in use_description"
          :key="'info2' + index"
          class="BookingInstructions-padd"
        >
          <p class="BookingDetails-title">
            {{ item.key }}
          </p>
          <p v-html="item.value" class="BookingDetails-content"></p>
        </div>
        <p
          v-if="
            use_description == '' ||
            use_description == null ||
            use_description == []
          "
          class="BookingDetails-information"
        >
          暂无信息
        </p>
      
    </div>

      <div class="BookingDetails-day">
        <p>*以上信息仅供参考，具体以景点当日实际公告信息为准</p>
      </div>
  </div>
   <div v-else>
     <img src="@/assets/tickets/SkeletonScreen.jpg" alt="">
   </div>
</template>

<script>
export default {
  data() {
    return {
      book_notice: [],
      cost_description: [],
      other_description: [],
      use_description: [],
      loading: true,
    };
  },
  mounted() {
    this.TicketDetails();
  },
  methods: {
    TicketDetails() {
      this.$api
        .post("third-tickets/member/ticket/detail", {
          short_name: "PanHe",
          product_id: this.$route.query.product_id,
        })
        .then((res) => {
          this.book_notice = res.book_notice;
          this.cost_description = res.cost_description;
          this.other_description = res.other_description;
          this.use_description = res.use_description;
         // setTimeout(() => {
          this.loading = false;
        //  }, 2000);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.BookingInstructions {
  background: #ffffff;
  overflow: hidden;
  .van-skeleton {
    margin-top: 30px;
    padding-bottom: 10px;
    .van-skeleton__title {
      width: 90px;
      height: 25px;
      border-radius: 20px;
    }
    .van-skeleton__content {
      border-radius: 20px;
    }
    .van-skeleton__row {
      //  height: 50px;
      // margin: 17px 0px;
      border-radius: 20px;
    }
  }
  .BookingDetails-day {
    font-size: 12px;
    color: #666;
    line-height: 60px;
    background: #fff;
    border-bottom: 5px solid #f3f8fb;
    p {
      margin-left: 20px;
    }
  }
  .BookingInstructions-padd {
    padding: 0px 20px;
    margin-top: 9px;
    border-bottom: 1px solid #efefef;
    padding-bottom: 12px;
  }
  .BookingInstructions-padd:last-of-type {
    border-bottom: none;
  }
  .Quick-reply {
    color: #333;
    font-weight: bold;
    margin-top: 10px;
    margin-bottom: 15px;
    padding-left: 20px;
    font-size: 15px;
  }
  .BookingInstructions-div {
    border-bottom: 5px solid #f3f8fb;
    padding-bottom: 10px;

    .BookingDetails-information {
      color: #666;
      font-size: 12px;
      font-weight: bold;
      padding-left: 20px;
    }
  }

  .BookingDetails-title {
    color: #333;
    font-size: 12px;
    font-weight: bold;

    .BookingDetails-content-text {
      float: right;
      width: 70%;
      font-weight: normal;
      color: #333333;
      vertical-align: middle;
      margin-top: 15px;
      line-height: 23px;
    }
    .BookingDetails-title-key {
      float: left;
      padding: 3px 5px;
      background: #fff5ed;
      color: #ff7500;
      margin-top: 15px;
    }
  }

  .BookingDetails-content {
    font-size: 12px;
    color: #666;
    line-height: 20px;
    background: #fff;

    margin-top: 10px;
    /deep/ img {
      width: 100%;
      margin: 10px 0px;
    }
  }
}
</style>
